import locationImage from '@/assets/avatar/location.gif'
import teamAvatar from '@/assets/avatar/team.gif'
import transformParticipant from '@/worker/transformer/transformParticipant'

export default function transformTeam(team) {
  return {
    avatar: team.avatar ?? teamAvatar,
    image: team.image ?? locationImage,
    url: {
      name: 'teams.detail',
      params: { id: team.id }
    },
    members: team.members ? team.members.map(transformParticipant) : [],
    ...team
  }
}
